// document.addEventListener('DOMContentLoaded', function () {
//     const menuItems = document.querySelectorAll('.menu-item');
//     const metaobjects = document.querySelectorAll('.metaobject-item');

//     menuItems.forEach(function (menuItem) {
//       menuItem.addEventListener('mouseover', function () {
//         const hoveredTitle = menuItem.getAttribute('data-title');
//         menuItem.classList.add('active');

//         metaobjects.forEach(function (metaobject) {
//           const metaobjectTitle = metaobject.getAttribute('data-metaobject-title');

//           if (hoveredTitle === metaobjectTitle) {
//             metaobject.classList.add('active');
//           } else {
//             metaobject.classList.remove('active');
//           }
//         });
//       });

//       menuItem.addEventListener('mouseout', function () {
//         menuItem.classList.remove('active');
//         metaobjects.forEach(function (metaobject) {
//           metaobject.classList.remove('active');
//         });
//       });
//     });
//   });

  // const menuItems = document.querySelectorAll('.menu-item');
  // const metaobjectItem = document.querySelector('.metaobject_item-2 .featured_2up_content');

  // menuItems.forEach(function (menuItem) {
  //   menuItem.addEventListener('mouseover', function () {
  //     // Get data attributes from the hovered menu item
  //     const metaImg = menuItem.getAttribute('data-metaimg');
  //     const metaTitle = menuItem.getAttribute('data-metatitle');
  //     const metaText = menuItem.getAttribute('data-metatext');
      
  //     // Check if all data attributes are valid (not null/undefined/empty)
  //     if (metaImg && metaTitle && metaText) {
  //       // Replace the content inside the metaobject-item
       
  //       metaobjectItem.querySelector('img').src = metaImg;
  //       metaobjectItem.querySelector('h3').textContent = metaTitle;
  //        console.log("rr"+metaTitle);
  //       metaobjectItem.querySelector('p').textContent = metaText;
  //     }
  //   });

  //   menuItem.addEventListener('mouseout', function () {
  //     // Optional: Reset content on mouse out if necessary
  //     // You can comment/remove the code below if resetting is not required
  //     metaobjectItem.querySelector('img').src = "https://coupchampagne.com/cdn/shop/files/image_56.png?v=1732789909&width=1000";
  //     metaobjectItem.querySelector('h3').textContent = "Title";
  //     metaobjectItem.querySelector('p').textContent = "Text";
  //   });
  // });
document.addEventListener('DOMContentLoaded', function () {
  const menuItems = document.querySelectorAll('.menu-item');
  const metaObjects = document.querySelectorAll('.metaobjectItem');

  menuItems.forEach((menuItem) => {
    menuItem.addEventListener('mouseover', () => {
      const hoveredTitle = menuItem.getAttribute('data-title'); // Get `data-title` of hovered menu-item

      metaObjects.forEach((metaObject) => {
        const metaObjectTitle = metaObject.getAttribute('data-metaobject-title'); // Get `data-metaobject-title`

        if (hoveredTitle === metaObjectTitle) {
          metaObject.style.display = 'block'; // Show metaobject if titles match
        } else {
          metaObject.style.display = 'none'; // Hide metaobject if titles don't match
        }
      });
    });

    menuItem.addEventListener('mouseout', () => {
      // Optionally, hide all metaobjects on mouseout
      metaObjects.forEach((metaObject) => {
        metaObject.style.display = 'none';
      });
    });
  });
});




// $('.sub_menu_title').click(function (e) {
//   e.preventDefault();
//   $(this).toggleClass('active'); 
//   $(this).siblings('.submenu').slideToggle();
//   $('.sub_menu_title').not(this).removeClass('active'); 
//   $('.submenu').not($(this).siblings('.submenu')).slideUp();
// });

$('.close_menu').click(function () {
  $('.menu-drawer').addClass('close_drawer');
  $('#Details-menu-drawer-container').removeAttr('open');
  $('.header__icon--menu').attr('aria-expanded', 'false');
  $('body').removeClass('overflow-hidden-tablet');
});


const readMoreBtn = document.querySelector('.read-more-button');
const text = document.querySelector('.product__description');

if (readMoreBtn) {
  readMoreBtn.addEventListener('click', () => {
    // Capture the button's position relative to the viewport
    const buttonY = readMoreBtn.getBoundingClientRect().top;

    // Toggle the "more" class
    text.classList.toggle('more');

    // Change button label
    readMoreBtn.innerHTML = text.classList.contains('more') ? 'Read Less' : 'Read More';

    // Force page to stay at the same visual spot
    const newButtonY = readMoreBtn.getBoundingClientRect().top;
    window.scrollBy({
      top: newButtonY - buttonY,
      left: 0,
      behavior: 'instant' // use 'smooth' if you want an animation
    });
  });
}


document.addEventListener("DOMContentLoaded", function () {
  var splide = new Splide(".slick_slider_fade", {
    type: "fade",
    rewind: true,
    perPage: 1,
    adaptiveHeight: true,
    pagination: false,
    arrows: false,
    speed: 1000,
    autoplay: true,
    interval: 3000,
    pauseOnHover: true,    
    
  });

  splide.mount();
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".img_slider").forEach(function (slider) {
    new Splide(slider, {
      type: "fade",
      rewind: true,
      perPage: 1,
      adaptiveHeight: true,
      pagination: false,
      arrows: false,
      speed: 1000,
      autoplay: true,
      interval: 3000,
      pauseOnHover: true,
    }).mount();
  });
});


document.addEventListener("DOMContentLoaded", function() {
  const deliveryContainer = document.getElementById("delivery-estimate");
  if (!deliveryContainer) return;

  // UPS Holidays (Add or update yearly)
  const holidays = [
    "2025-01-01", // New Year's Day
    "2025-05-26", // Memorial Day
    "2025-07-04", // Independence Day
    "2025-09-01", // Labor Day
    "2025-11-27", // Thanksgiving
    "2025-12-25"  // Christmas
  ];

  function isHoliday(date) {
    return holidays.includes(date.toISOString().split("T")[0]);
  }

  function addBusinessDays(date, days) {
    let result = new Date(date);
    let addedDays = 0;
    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6 && !isHoliday(result)) {
        addedDays++;
      }
    }
    return result;
  }

  function formatDate(date) {
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  }

  function getEstimates() {
    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(12, 0, 0, 0); // Noon PST cutoff

    let orderDate = new Date(now);
    if (now > cutoff) {
      orderDate.setDate(orderDate.getDate() + 1);
    }

    // Skip weekends/holidays for order date
    while (orderDate.getDay() === 0 || orderDate.getDay() === 6 || isHoliday(orderDate)) {
      orderDate.setDate(orderDate.getDate() + 1);
    }

    // Express: 1–3 business days
    const expressStart = addBusinessDays(orderDate, 1);
    const expressEnd   = addBusinessDays(orderDate, 3);

    // Standard: 3-day processing + 1–5 business days
    const standardStart = addBusinessDays(orderDate, 3 + 1);
    const standardEnd   = addBusinessDays(orderDate, 3 + 5);

    return `
      <div><strong>Expected Delivery (United States)</strong></div>
      <div>Express: ${formatDate(expressStart)} – ${formatDate(expressEnd)}</div>
      <div>Standard: ${formatDate(standardStart)} – ${formatDate(standardEnd)}</div>
    `;
  }

  deliveryContainer.innerHTML = getEstimates();
});

        $('#properties_line1').keyup(function(e) {
             var maxLines = 2;
            var maxLength = 15;
            var notifyTextArea = false;
      
            var lines = $(this).val().split("\n");
            var newLines = [];
            for (var i = 0; i < lines.length; i++) {
                if(i >= maxLines) {
                  notifyTextArea = true;
                  break;
                }
                if (lines[i].length > maxLength) {
                    newLines[i] = lines[i].substring(0, maxLength);
                    notifyTextArea = true;
                } else newLines[i] = lines[i];
            }
            $(this).val(newLines.join("\n"));
            if(notifyTextArea == true){
                console.log('error');
                $('#line1_error').css({'transition' : 'unset','opacity':"1"});
                setTimeout(function(){$('#line1_error').css({'transition' : 'opacity 2s 1s','opacity':"0"});},2000);
                return false;
            } else return true;

          
        });
        
        
        $('#properties_line41').keyup(function(e) {
            var maxLength = 18;
            var notifyTextArea = false;
      
            var val = $(this).val().toUpperCase();

            if (val.length > maxLength) {
                val = val.substring(0, maxLength);
                notifyTextArea = true;
            };
 
            $(this).val(val);
            if(notifyTextArea == true){
                console.log('error');
                $('#line41_error').css({'transition' : 'unset','opacity':"1"});
                setTimeout(function(){$('#line41_error').css({'transition' : 'opacity 2s 1s','opacity':"0"});},2000);
                return false;
            } else return true;
      
        });
        
        
        $('#properties_line11').keyup(function(e) {
          
             var maxLines = 2;
            var maxLength = 17;
            var notifyTextArea = false;
      
            var lines = $(this).val().toUpperCase().split("\n");
            var newLines = [];
            for (var i = 0; i < lines.length; i++) {
                if(i >= maxLines) {
                  notifyTextArea = true;
                  break;
                }
                if (lines[i].length > maxLength) {
                    newLines[i] = lines[i].substring(0, maxLength);
                    notifyTextArea = true;
                } else newLines[i] = lines[i];
            }
            $(this).val(newLines.join("\n"));
            if(notifyTextArea == true){
                console.log('error');
                $('#line11_error').css({'transition' : 'unset','opacity':"1"});
                setTimeout(function(){$('#line11_error').css({'transition' : 'opacity 2s 1s','opacity':"0"});},2000);
                return false;
            } else return true;

          
             
      
        });
      
        
        $('#properties_line12').keyup(function(e) {
            
            var maxLines = 2;
            var maxLength = 20;
            var notifyTextArea = false;
      
            var lines = $(this).val().split("\n");
            var newLines = [];
            for (var i = 0; i < lines.length; i++) {
                if(i >= maxLines) {
                  notifyTextArea = true;
                  break;
                }
                if (lines[i].length > maxLength) {
                    newLines[i] = lines[i].substring(0, maxLength);
                    notifyTextArea = true;
                } else newLines[i] = lines[i];
            }
            $(this).val(newLines.join("\n"));
            if(notifyTextArea == true){
                console.log('error');
                $('#line12_error').css({'transition' : 'unset','opacity':"1"});
                setTimeout(function(){$('#line12_error').css({'transition' : 'opacity 2s 1s','opacity':"0"});},2000);
                return false;
            } else return true;
      
        });
        
        
        $('#properties_line2').keyup(function(e) {
            
            var maxLines = 2;
            var maxLength = 20;
            var notifyTextArea = false;
      
            var lines = $(this).val().split("\n");
            var newLines = [];
            for (var i = 0; i < lines.length; i++) {
                if(i >= maxLines) {
                  notifyTextArea = true;
                  break;
                }
                if (lines[i].length > maxLength) {
                    newLines[i] = lines[i].substring(0, maxLength);
                    notifyTextArea = true;
                } else newLines[i] = lines[i];
            }
            $(this).val(newLines.join("\n"));
            if(notifyTextArea == true){
                console.log('error');
                $('#line2_error').css({'transition' : 'unset','opacity':"1"});
                setTimeout(function(){$('#line2_error').css({'transition' : 'opacity 2s 1s','opacity':"0"});},2000);
                return false;
            } else return true;
      
        });

         $('#properties_line4').keyup(function(e) {
          
             var maxLength = 300;
            var notifyTextArea = false;
           
      
            var val = $(this).val();

            if (val.length > maxLength) {
                val = val.substring(0, maxLength);
                notifyTextArea = true;
            };
 
            $(this).val(val);
            if(notifyTextArea == true){
                console.log('error');
                $('#line4_error').css({'transition' : 'unset','opacity':"1"});
                setTimeout(function(){$('#line4_error').css({'transition' : 'opacity 2s 1s','opacity':"0"});},2000);
                return false;
            } else return true;
      
        });

         $('#properties_line3').keyup(function(e) {
            
            var maxLength = 18;
            var notifyTextArea = false;
      
            var val = $(this).val().toUpperCase();

            if (val.length > maxLength) {
                val = val.substring(0, maxLength);
                notifyTextArea = true;
            };
 
            $(this).val(val);
            if(notifyTextArea == true){
                console.log('error');
                $('#line3_error').css({'transition' : 'unset','opacity':"1"});
                setTimeout(function(){$('#line3_error').css({'transition' : 'opacity 2s 1s','opacity':"0"});},2000);
                return false;
            } else return true;
      
        });
  
        